export default {
  intro: 'Veuillez saisir les informations relatives à votre carte de crédit!',
  ccNumber: 'Numéro de carte',
  expDate: 'Date de validité',
  cvv: 'CVV',
  submit: 'Soumettre',
};
